<template>
    <div class="oauth-login-wrap">
        <!-- loading 状态 -->
        <div v-if="status === 'loading'" class="oauth-login-box">
            <div class="loading_div">
                <Spin size="large"></Spin>
            </div>

            <p class="tip-text">OAuth授权登录中，请稍候...</p>
        </div>

        <!-- 成功状态 -->
        <div v-else-if="status === 'success'" class="oauth-login-box">
            <Icon type="ios-checkmark-circle" size="64" color="#19be6b" />
            <p class="tip-text success">登录成功，正在跳转...</p>
        </div>

        <!-- 失败状态 -->
        <div v-else-if="status === 'error'" class="oauth-login-box">
            <Icon type="ios-close-circle" size="64" color="#ed4014" />
            <p class="tip-text error">{{ errorMsg }}</p>
            <Button type="primary" @click="handleRetry">
                重新登录
            </Button>
        </div>
    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
var Base64 = require("js-base64").Base64;

export default {
    created() {
        if (window.location.hostname == "localhost") {
            this.cookie_domain = "localhost";
        } else {
            this.cookie_domain = process.env.VUE_APP_COOKIES_DOMAIN;
        }
    },
    data() {
        return {
            cookie_domain:'',
            state: "",
            code: "",
            status: "loading", // loading | success | error
            errorMsg: "",
            scan_time: 0,
            // 用户首页
            user_index_path: "/user/index/v2?type=message",
            user_login_path: '/'
        };
    },
    mounted() {
        const { code, state } = this.$route.query;

        if (!code) {
            this.status = "error";
            this.errorMsg = "微信授权失败：缺少 code";
            return;
        }

        if (!state) {
            this.status = "error";
            this.errorMsg = "微信授权失败：缺少 state";
            return;
        }

        this.code = code;
        this.state = state;
        this.login();
    },
    methods: {
        login() {
            var that = this;
            var browser_id = this.$cookies.get("dx_browser_id");
            if (browser_id == undefined) {
                browser_id = "";
            }

            var obj = {
                browser_id: browser_id,
                code: that.code,
                state: that.state,
            };

            http(
                "post",
                process.env.VUE_APP_HOST + "/login_dx/oauth_login",
                obj,
                false,
                'staff'
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.status = "success";
                        console.log(res)
                        var b64_str = Base64.decode(res.data);
                        console.log('b64str----', b64_str)
                        let data = JSON.parse(b64_str);
                        console.log(b64_str)
                        console.log(data)

                        that.$cookies.set(
                            "dx_token",
                            data.token,
                            data.cookie_exp,
                            "/",
                            that.cookie_domain
                        );
                        that.$cookies.set(
                            "dx_private_key",
                            data.private_key,
                            data.cookie_exp,
                            "/",
                            that.cookie_domain
                        );
                        that.$cookies.set(
                            "dx_public_key",
                            data.public_key,
                            data.cookie_exp,
                            "/",
                            that.cookie_domain
                        );

                        that.$Message.success("登录成功");

                        setTimeout(function () {
                            if (res.data.redirect_url) {
                                open_new_page(res.data.redirect_url, "_self");
                            } else {
                                that.$router.push({
                                    path: that.user_index_path,
                                    query: { page: "message" },
                                });
                            }
                        }, 200);
                    } else {
                        that.status = "error";
                        that.errorMsg = res.msg || "登录失败，请重试";

                        if (res.data && res.data.scan_time > 0) {
                            that.scan_time = res.data.scan_time;
                        }
                    }
                })

        },
        handleRetry() {
            open_new_page(this.user_login_path, '_self')
        },
    },
};
</script>

<style scoped>
.loading_div {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px;
}

.oauth-login-wrap {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f7f8fa;
}

.oauth-login-box {
    text-align: center;
    padding: 40px 24px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    width: 320px;
    box-sizing: border-box;
    position: relative;
}

.tip-text {
    margin-top: 16px;
    font-size: 14px;
    color: #666;
    line-height: 1.6;
}

.tip-text.success {
    color: #19be6b;
}

.tip-text.error {
    color: #ed4014;
    margin-bottom: 16px;
}
</style>